import React from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";
import colorList from "./colorsList";
import "./legend.scss";

const Legend = ({ data, width }) => {
  if (!data || data.length === 0) return;

  let arr = data.map((obj) => obj["name"]);
  var colors = d3.scale.ordinal().range(colorList);
  const clr = function (d, i) {
    return colors(i);
  };

  return (
    <div className="ListParent" style={{ width: width }}>
      {arr.map((d, i) => (
        <div style={{ float: "left" }} key={d} className="LegendChild">
          {" "}
          <span style={{ color: clr(d, i), fontSize: "20px" }}>●</span> {d}
        </div>
      ))}
    </div>
  );
};

Legend.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
};
export default Legend;



// WEBPACK FOOTER //
// ./src/components/d3Components/MultiLineChart/Legendhtml.js